import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _URLSearchParams from "@babel/runtime-corejs3/core-js-stable/url-search-params";
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import { useEffect } from "react";
import { getConfigValue } from "@jutro/config";
import { useAuthInternal } from "./AuthContext";
import { getBasePath } from "./GenericAuthProvider";
export var LoginCallback = function () {
  var _useAuthInternal = useAuthInternal(),
    oidc = _useAuthInternal.oidc,
    setIsLoginPending = _useAuthInternal.setIsLoginPending,
    setError = _useAuthInternal.setError,
    onLocationChange = _useAuthInternal.onLocationChange;
  return useEffect(function () {
    var _ref,
      hasChanged = !1,
      playCallbackAsync = (_ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
        var queryParams, _queryParams$get, _yield$oidc$loginCall, _ref2, callbackPath, pathWithoutBase, logoutPath, shouldRedirectToCallbackPath;
        return _regeneratorRuntime.wrap(function (_context) {
          for (;;) switch (_context.prev = _context.next) {
            case 0:
              if (!(queryParams = new _URLSearchParams(new _URL(window.location.href).search)).has("error")) {
                _context.next = 5;
                break;
              }
              return setError({
                errorCode: queryParams.get("error"),
                message: null !== (_queryParams$get = queryParams.get("error_description")) && void 0 !== _queryParams$get ? _queryParams$get : ""
              }), null == onLocationChange || onLocationChange("/"), _context.abrupt("return");
            case 5:
              return _context.prev = 5, _context.next = 8, oidc.loginCallbackAsync();
            case 8:
              if (_context.t1 = _yield$oidc$loginCall = _context.sent, _context.t0 = null !== _context.t1, !_context.t0) {
                _context.next = 12;
                break;
              }
              _context.t0 = void 0 !== _yield$oidc$loginCall;
            case 12:
              if (!_context.t0) {
                _context.next = 16;
                break;
              }
              _context.t2 = _yield$oidc$loginCall, _context.next = 17;
              break;
            case 16:
              _context.t2 = {};
            case 17:
              _ref2 = _context.t2, callbackPath = _ref2.callbackPath, pathWithoutBase = null == callbackPath ? void 0 : callbackPath.replace(getBasePath(), ""), logoutPath = getConfigValue("JUTRO_AUTH_LOGOUT_REDIRECT_PATH", "/logout"), shouldRedirectToCallbackPath = pathWithoutBase && pathWithoutBase !== logoutPath, null == onLocationChange || onLocationChange(shouldRedirectToCallbackPath ? pathWithoutBase : "/"), _context.next = 28;
              break;
            case 25:
              _context.prev = 25, _context.t3 = _context.catch(5), hasChanged || (setError(_context.t3), null == onLocationChange || onLocationChange("/"));
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5, 25]]);
      })), function () {
        return _ref.apply(this, arguments);
      });
    return setIsLoginPending(!0), playCallbackAsync().then(function () {
      return setIsLoginPending(!1);
    }).then(function () {
      window.opener && (testcafePolyfill(), window.opener.postMessage({
        event: "JUTRO_LOGIN_CALLBACK_FINISHED"
      }, window.origin));
    }), function () {
      hasChanged = !0;
    };
  }, [oidc, onLocationChange, setError, setIsLoginPending]), null;
};
var testcafePolyfill = function () {
  if (!!window["%hammerhead%"]) {
    var _context2,
      _context3,
      authState = _reduceInstanceProperty(_context2 = _filterInstanceProperty(_context3 = _Object$keys(sessionStorage)).call(_context3, function (key) {
        return _startsWithInstanceProperty(key).call(key, "oidc.");
      })).call(_context2, function (storage, key) {
        return _objectSpread(_objectSpread({}, storage), {}, _defineProperty({}, key, sessionStorage.getItem(key)));
      }, {});
    window.opener.postMessage({
      event: "AUTHENTICATION_FINISHED",
      authState: authState
    }, window.opener.origin);
  }
};